import {requestTimeout, handleResponse} from '../helpers'

const apiUrl = process.env.REACT_APP_API_URL
const accessToken = process.env.REACT_APP_ACCESS_TOKEN
const apiMaxTime = process.env.REACT_APP_API_EXEC_TIME
var base_uri = "config"

export const configApi = {
    _get,
    _delete,
    _update,    
};



async function _get() {    
    let token = localStorage.getItem(accessToken)
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        }        
    };
    return requestTimeout(apiMaxTime,fetch(apiUrl + base_uri, requestOptions))                    
                .then(handleResponse)
                .then((response) => {                        
                    return response
                })

        
}



async function _update(data, id) {    
    
    let token = localStorage.getItem(accessToken)
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify(data)
    };
    return requestTimeout(apiMaxTime,fetch(apiUrl + base_uri +'/'+id, requestOptions))                    
                .then(handleResponse)
                .then((response) => {                        
                    return response
                })                
        
}

async function _delete(id) {    
    
    let token = localStorage.getItem(accessToken)
    const requestOptions = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        }
    };
    return requestTimeout(apiMaxTime,fetch(apiUrl + base_uri +'/'+id, requestOptions))                    
                .then(handleResponse)
                .then((response) => {                        
                    return response
                })                
        
}

